import { Grid } from "@mui/material";
import SearchableSelect, {
  SelectOption,
} from "app/components/SearchableSelect";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectUserGroups } from "store/global/fields/selector";
import { actions } from "store/global/fields/slice";
import { useStyles } from "../styles";
interface TProps {
  value: number;
  changeValue: (value: number) => void;
  disabled?: boolean;
  showAll: boolean;
  xs?: number;
}
const UserGroupsFiled = (props: TProps) => {
  const dispatch = useDispatch();
  const styles = useStyles();
  const List = useSelector(selectUserGroups);

  const { t } = useTranslation();

  useEffect(() => {
    dispatch(actions.getUserGroupList());
    return () => {};
  }, []);

  const options: SelectOption[] = List.items.map((item: any) => ({
    label: item.userGroupName,
    value: item.id,
    raw: item,
  }));

  return (
    <Grid item xs={props.xs ? props.xs : 2}>
      <label className={styles.label}>{t("USERS.USER_GROUP")}</label>
      <SearchableSelect
        options={options}
        value={props.value ?? ""}
        onChange={(val) => props.changeValue(Number(val))}
        disabled={props.disabled}
        searchable
        className={styles.textEnabled}
        showAllOption={
          props.showAll ? { label: t("COMMON.ALL"), value: 0 } : undefined
        }
      />
    </Grid>
  );
};
export default UserGroupsFiled;
